import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/auth/AuthContext';
import { LoginPage } from '@/pages/LoginPage';
import { LogoutPage } from '@/pages/LogoutPage';
import { AISidebar } from '@/components/ai/AISidebar';
import { Toaster } from '@/components/ui/toaster';
import { Seo } from '@/components/Seo';
import { SEO } from '@/lib/seo';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AuthenticatedWorkspace() {
  const { selectedEmployer } = useAuth();
  // Remount all module views when company changes so local state (open chats,
  // documents, designer graphs, etc.) cannot leak across employers.
  return (
    <>
      <Seo title={SEO.siteName} description={SEO.defaultDescription} path="/" noIndex />
      <AISidebar key={selectedEmployer?.id ?? 'none'} />
    </>
  );
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AuthenticatedWorkspace />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
